import { createSlice } from "@reduxjs/toolkit";

const errorSlice = createSlice({
  name: "global",
  initialState: { error: null },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;
export const selectGlobalError = (state) => state.global.error;
export default errorSlice.reducer;
